module.exports = __webpack_public_path__ + "static/media/Countdown.9bb56bbc.svg";